<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Login v1 -->
      <b-card class="mb-0">
        <h4 class="brand-text text-primary ml-1 text-header">
          Welcome
        </h4>
        <div class="content-company-logo">
          <b-link
            to="/"
          >
            <img
              id="company-logo"
              :src="require('@/assets/svg/maxlogo.png')"
              alt="Company Logo"
            >
          </b-link>
        </div>
        <h5 class="brand-text text-header-sub">
          Please sign-in to continue
        </h5>
        <!-- form -->
        <validation-observer
          ref="loginForm"
          #default="{invalid}"
        >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent="login"
          >
            <!-- password -->
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Password"
                rules="required"
              >
                <div class="label-link-group">
                  <a
                    v-b-modal.modal-support
                    href="#"
                  >Forgot Password?</a>
                </div>
                <b-input-group
                  class="input-group-merge password-group-icon"
                  :class="errors.length > 0 || isError ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="login-password"
                    placeholder="Password"
                    :class="{ 'is-invalid': isError }"
                  />

                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small
                  v-show="isError & errors.length < 1"
                  class="text-danger"
                >
                  {{ errorMessage }}
                </small>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <div class="d-flex justify-content-between container-button">
              <div>
                <b-link
                  :to="{ name: 'auth-username' }"
                  class="btn btn-block waves-effect waves-float waves-light btn-sign-up"
                >
                  <span>Back</span>
                </b-link>
              </div>
              <div>
                <b-button
                  variant="primary"
                  type="submit"
                  block
                  :disabled="invalid"
                >
                  Next
                </b-button>
              </div>
            </div>
          </b-form>
        </validation-observer>
      </b-card>
      <NavGeneral />
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton,
  BForm,
  VBModal,
  BFormInput,
  BFormGroup,
  BCard,
  BLink,
  BInputGroup,
  BInputGroupAppend,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import NavGeneral from '@/views/component/NavGeneral.vue'

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BLink,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    NavGeneral,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      username: '',
      status: '',
      password: '',
      authUser: null,
      required,
      email,
      profileData: { },
      isError: false,
      errorMessage: '',
    }
  },
  computed: {
    ...mapGetters('auth', {
      getEmail: 'getEmail',
      getUsername: 'getUsername',
      getUserData: 'getUserData',
    }),
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  beforeCreate() {
    if (this.getUsername === null) return this.$router.push('auth-username')
    return true
  },
  created() {
    document.title = 'IOH Platform - Login'
  },
  methods: {
    ...mapMutations('finance', {
      setCreditBalance: 'SET_CREDIT_BALANCE',
    }),
    ...mapActions('auth', ['checkPassword']),
    ...mapActions('navigation', [
      'navigationMenu',
    ]),
    login() {
      this.checkPassword({
        email: this.getEmail,
        password: this.password,
      }).then(response => {
        if (!response.status) {
          this.isError = true
          this.errorMessage = response.message
          return false
        }
        this.navigationMenu().then(() => {
          this.$router.push({ name: 'dashboard' })
        })
        this.setCreditBalance(this.getUserData.data.saldo)
        return true
      })
    },
  },
}
</script>
<style scoped>
.auth-inner {
  max-width: 337px !important;
}
  .brand-logo{
    margin-bottom: 18px !important;
  }
</style>
<style lang="scss" scoped>
@import '@core/scss/vue/pages/page-auth.scss';
.auth-inner {
  max-width: 337px !important;
}
.content-company-logo {
  text-align: center;
  margin-bottom: 18px;
  margin-top: 13px;
}
#company-logo {
  max-width: 180px;
  max-height: 50px;
  object-fit: contain;
}
.brand-text {
  text-align: center;
  color: #5e5873 !important;
  margin-top: 20px;
}
.btn-primary,
.btn-primary:focus {
  border: #6480BC !important;
  background-color: #6480BC !important;
}
.card {
  box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%) !important;
}
.text-header-sub,.text-header{
  font-family: 'Rubik', sans-serif;
}
.text-header-sub{
  margin-bottom: 18px;
}
.card{
  border-radius: 16px;
}
.text-header{
  font-weight: 600 !important;
  font-size: 18px;
  line-height: 21px;
}
.label-link-group{
  display: block;
  font-family: 'Rubik', sans-serif;
  font-weight: 500;
}
.label-link-group a{
  float: right;
  font-size: 12px;
  text-decoration: none;
  color: #5E5873;
}
.btn-sign-up{
  padding-left: 0px;
  color: #6480BC;
  font-weight: 600;
}
.btn-sign-up:hover{
  color: #6480BC;
}
.container-button{
  margin-bottom: 10px;
}
.navbar{
  margin-top: 16px;
  padding: 0;
}
.bg-info{
  background-color: transparent !important;
}
.nav-link{
  color: #6E6B7B !important;
  padding: 0 16px 0 5px !important;
}
.navbar-nav{
  flex-direction:unset;
}
</style>
